// extracted by mini-css-extract-plugin
export default {"table":"SoilParametersSection_table__PnRKq","wrapper":"SoilParametersSection_wrapper__+ieLy"};